import React from 'react'
import { hexToRGBA, specialFieldValidation } from '../../../../lib/utils'
import { Card, Col, Form, Input, Row, Select, Space, Switch, Typography, theme } from 'antd'
import { useSelector } from 'react-redux'
import { faContactBook, faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import SystemUsersTemplates from '../../utils/templates'

const { Text } = Typography

const RenderFormItems = ({
  activeRecord,
  isNewRecord,
  clientForm,
  specialFormState,
  setSpecialFormState,
  handleIsActive,
  handleRolesSelection,
  type,
  record
}) => {
  const state = useSelector((state) => state)
  const authState = useSelector((state) => state.auth)
  const { token } = theme.useToken()

  return (
    <Row gutter={[32, 24]}>
      <Col xs={24} lg={12}>
        <Card
          title={
            <Space size={12}>
              <div
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '10px',
                  backgroundColor: hexToRGBA(token.colorPrimary, 0.1),
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <FontAwesomeIcon icon={faUser} style={{ color: token.colorPrimary, fontSize: '18px' }} />
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                  <div>
                    <Text strong style={{ fontSize: '18px', display: 'block' }}>
                      Profile Details
                    </Text>
                    <Text type='secondary' style={{ fontSize: '14px' }}>
                      Basic user information and role settings
                    </Text>
                  </div>
                  <Form.Item
                    style={{ margin: 0 }}
                    name={SystemUsersTemplates.dataModel.isActive.key}
                    valuePropName='checked'
                  >
                    <Switch
                      disabled={
                        authState.agiliteUser.extraData.role.type !== 'admin' &&
                        authState.agiliteUser.extraData.role.type !== 'super_admin'
                      }
                      checkedChildren='Active'
                      unCheckedChildren='Inactive'
                      onChange={handleIsActive}
                      style={{ marginLeft: '16px' }}
                    />
                  </Form.Item>
                </div>
              </div>
            </Space>
          }
          bordered={false}
          style={{
            borderRadius: '16px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
            background: 'linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)',
            border: `1px solid ${hexToRGBA(token.colorBorder, 0.1)}`,
            height: '100%'
          }}
          bodyStyle={{ padding: '32px' }}
          headStyle={{
            borderBottom: 'none',
            backgroundColor: 'transparent',
            padding: '24px 32px 0 32px'
          }}
        >
          <Space direction='vertical' size={24} style={{ width: '100%' }}>
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <Form.Item
                  name={SystemUsersTemplates.dataModel.firstName.key}
                  label={
                    <Text strong style={{ fontSize: '15px' }}>
                      {SystemUsersTemplates.dataModel.firstName.label}
                    </Text>
                  }
                  rules={[
                    {
                      required: SystemUsersTemplates.dataModel.firstName.required,
                      message: SystemUsersTemplates.dataModel.firstName.validationMsg
                    }
                  ]}
                >
                  <Input
                    size='large'
                    onChange={(e) => {
                      specialFieldValidation(clientForm, specialFormState, setSpecialFormState, {
                        key: 'firstName',
                        event: e,
                        validationConfig: {
                          letters: { allowed: true, onlyCaps: false },
                          numbers: false,
                          spaces: true
                        }
                      })
                    }}
                    maxLength={50}
                    readOnly={!isNewRecord}
                    placeholder={SystemUsersTemplates.dataModel.firstName.placeholder}
                    style={{ borderRadius: '8px' }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name={SystemUsersTemplates.dataModel.lastName.key}
                  label={
                    <Text strong style={{ fontSize: '15px' }}>
                      {SystemUsersTemplates.dataModel.lastName.label}
                    </Text>
                  }
                  rules={[
                    {
                      required: SystemUsersTemplates.dataModel.lastName.required,
                      message: SystemUsersTemplates.dataModel.lastName.validationMsg
                    }
                  ]}
                >
                  <Input
                    size='large'
                    onChange={(e) => {
                      specialFieldValidation(clientForm, specialFormState, setSpecialFormState, {
                        key: 'lastName',
                        event: e,
                        validationConfig: {
                          letters: { allowed: true, onlyCaps: false },
                          numbers: false,
                          spaces: true
                        }
                      })
                    }}
                    maxLength={50}
                    readOnly={!isNewRecord}
                    placeholder={SystemUsersTemplates.dataModel.lastName.placeholder}
                    style={{ borderRadius: '8px' }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              name={SystemUsersTemplates.dataModel.role.key}
              label={
                <Text strong style={{ fontSize: '15px' }}>
                  {SystemUsersTemplates.dataModel.role.label}
                </Text>
              }
              rules={[
                {
                  required: SystemUsersTemplates.dataModel.role.required,
                  message: SystemUsersTemplates.dataModel.role.validationMsg
                }
              ]}
            >
              <Select
                size='large'
                disabled={type !== 'system'}
                placeholder='Select a role'
                style={{ borderRadius: '8px' }}
                options={[
                  {
                    label: '-Select a role-',
                    value: ''
                  },
                  ...handleRolesSelection()
                ]}
              />
            </Form.Item>

            {(activeRecord?.extraData.role.type === 'medical_professional' || type === 'medical') && (
              <Form.Item
                name={['extraData', 'clinics']}
                label={
                  <Space>
                    <Text strong style={{ fontSize: '15px' }}>
                      Linked Clinics
                    </Text>
                    <Text style={{ color: token.colorError }}>*</Text>
                  </Space>
                }
                rules={[
                  {
                    required: SystemUsersTemplates.dataModel.clinics.required,
                    message: 'Select Medical Professionals linked clinics'
                  }
                ]}
              >
                <Select
                  mode='multiple'
                  size='large'
                  placeholder='Select clinics'
                  style={{ borderRadius: '8px' }}
                  filterOption={(input, option) => {
                    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }}
                  options={[
                    ...state.clinics.data.map((clinic) => ({
                      label: clinic.name,
                      value: clinic._id
                    }))
                  ]}
                />
              </Form.Item>
            )}

            {(activeRecord?.extraData.role.type === 'reception' || record?.extraData?.role?.type === 'reception') && (
              <Form.Item
                name={['extraData', 'clinics']}
                label={
                  <Space>
                    <Text strong style={{ fontSize: '15px' }}>
                      Linked Clinic
                    </Text>
                    <Text style={{ color: token.colorError }}>*</Text>
                  </Space>
                }
                rules={[
                  {
                    required: SystemUsersTemplates.dataModel.clinics.required,
                    message: "Select Reception's linked clinic"
                  }
                ]}
              >
                <Select
                  size='large'
                  placeholder='Select clinic'
                  style={{ borderRadius: '8px' }}
                  onChange={(value) => {
                    clientForm.setFieldValue(SystemUsersTemplates.dataModel.clinics.key, [value])
                  }}
                  options={[
                    ...state.clinics.data.map((clinic) => ({
                      label: clinic.name,
                      value: clinic._id
                    }))
                  ]}
                />
              </Form.Item>
            )}
          </Space>
        </Card>
      </Col>

      <Col xs={24} lg={12}>
        <Card
          title={
            <Space size={12}>
              <div
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '10px',
                  backgroundColor: hexToRGBA(token.colorSuccess, 0.1),
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <FontAwesomeIcon icon={faContactBook} style={{ color: token.colorSuccess, fontSize: '18px' }} />
              </div>
              <div>
                <Text strong style={{ fontSize: '18px', display: 'block' }}>
                  Contact Details
                </Text>
                <Text type='secondary' style={{ fontSize: '14px' }}>
                  Email and phone contact information
                </Text>
              </div>
            </Space>
          }
          bordered={false}
          style={{
            borderRadius: '16px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
            background: 'linear-gradient(135deg, #ffffff 0%, #f0fff4 100%)',
            border: `1px solid ${hexToRGBA(token.colorBorder, 0.1)}`,
            height: '100%'
          }}
          bodyStyle={{ padding: '32px' }}
          headStyle={{
            borderBottom: 'none',
            backgroundColor: 'transparent',
            padding: '24px 32px 0 32px'
          }}
        >
          <Space direction='vertical' size={24} style={{ width: '100%' }}>
            <Form.Item
              name={SystemUsersTemplates.dataModel.email.key}
              label={
                <Text strong style={{ fontSize: '15px' }}>
                  {SystemUsersTemplates.dataModel.email.label}
                </Text>
              }
              rules={[
                {
                  required: isNewRecord ? SystemUsersTemplates.dataModel.email.required : false,
                  message: SystemUsersTemplates.dataModel.email.validationMsg
                }
              ]}
            >
              <Input
                type='email'
                size='large'
                maxLength={70}
                readOnly={!isNewRecord}
                placeholder={SystemUsersTemplates.dataModel.email.placeholder}
                style={{ borderRadius: '8px' }}
              />
            </Form.Item>

            <Form.Item
              name={SystemUsersTemplates.dataModel.phoneNumber.key}
              label={
                <Text strong style={{ fontSize: '15px' }}>
                  {SystemUsersTemplates.dataModel.phoneNumber.label}
                </Text>
              }
              rules={[
                {
                  required: isNewRecord ? SystemUsersTemplates.dataModel.phoneNumber.required : false,
                  message: SystemUsersTemplates.dataModel.phoneNumber.validationMsg
                }
              ]}
            >
              <Input
                addonBefore='+27'
                size='large'
                placeholder='8288*****'
                maxLength={10}
                minLength={9}
                style={{ borderRadius: '8px' }}
                onChange={(e) => {
                  specialFieldValidation(clientForm, specialFormState, setSpecialFormState, {
                    key: 'phoneNumber',
                    event: e,
                    validationConfig: {
                      letters: { allowed: false, onlyCaps: true },
                      numbers: true
                    }
                  })
                }}
              />
            </Form.Item>
          </Space>
        </Card>
      </Col>
    </Row>
  )
}

export default RenderFormItems
